const SailsInfo = {
  'pages_sales_payment.title': '청구정보',
  'pages_sales_payment.month': '월',
  'pages_sales_payment.company_name': '회사명',
  'pages_sales_payment.dept': '사업부명',
  'pages_sales_payment.total_amount': '총 청구 금액',
  'pages_sales_payment.paid_status': '납부 상태',
  'pages_sales_payment.unpaid_amount': '납부전 금액',
  'pages_sales_payment.download_filename': '청구 정보',

  'pages_sales_payment.all_pay': '완납',
  'pages_sales_payment.not_all_pay': '부분납',
  'pages_sales_payment.before_pay': '납부전',
  'pages_sales_payment.thanks_1': '글로벌 IT 서비스 기업 베스핀글로벌은 고객님께 안정적이고 믿을 수 있는 최상의 서비스를 제공하도록 최선을 다하겠습니다.',
  'pages_sales_payment.thanks_2': '감사합니다.',
  'pages_sales_payment.used_amount_detail': '이용료 상세 내역',
  'pages_sales_payment.used_amount_total': '청구 금액 합계',
  'pages_sales_payment.used_amount_vat': '부가세',
  'pages_sales_payment.used_amount': '청구 금액',
  'pages_sales_payment.sales_detail': '청구 금액',
  'pages_sales_payment.user_detail': '사용 내역',
  'pages_sales_payment.bill': '청구서',
  'pages_sales_payment.bill_download': '청구서 다운로드',
  'pages_sales_payment.bill_confirm': '확인',
}

export default SailsInfo



// WEBPACK FOOTER //
// ./src/lang/sales/SalesInfo.kr.js